import {Component, HostBinding, OnDestroy} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";

import {SearchParam} from "../../shared/defines/client.const";
import {makeImageUrl} from "../../shared/defines/client.func";
import {VideoStory} from "../../shared/models/video.model";
import {VideoService} from "../../shared/services/video/video.service";

@Component({
  selector: 'app-dialect-story',
  templateUrl: './dialect-story.component.html',
  styleUrls: ['./dialect-story.component.scss']
})
export class DialectStoryComponent implements OnDestroy {
  @HostBinding('class') class = 'all-menu-group-list flex-grow';
  @HostBinding('style.display') styleBlock = 'block';

  protected readonly makeImageUrl = makeImageUrl;

  // 라우터에서 넣어주는 값. (TODO: 초기화에 유의해야 함)
  private queryParams: SearchParam | null = null;

  protected story_no: number | null = null;
  protected videoStory: VideoStory | null = null;

  private queryParams$?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private videoSvc: VideoService,
  ) {

    /******************************************************************************************
     * 라우터 파리미터 변경 핸들러 - 주소 뒤의 파라미터를 받아오는 곳. ( ?keyword=... )
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * 처음 화면에 들어올 때, 라우터 주소 변견 핸들러보다 더 먼저 불려진다. (이상하지만 그렇다)
     *
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.queryParams$ = this.route.queryParams
      .subscribe(params => {
        this.queryParams = {...params};

        if ('story' in params) {
          this.story_no = parseInt(params['story'], 10);

          this.videoSvc.GetStoryList().subscribe((listStory: VideoStory[]) => {
            const videoStory = listStory.find(story => story.no === this.story_no);

            // console.warn('DialectStoryComponent.constructor() videoStory = ', this.story_no, typeof(this.story_no));
            if (videoStory === undefined) {
              throw new Error('DialectStoryComponent.constructor() invalid story_no = ' + this.story_no);
            }
            else {
              this.videoStory = videoStory;
            }
          });
        }
      });

  }

  ngOnDestroy() {
    this.queryParams$?.unsubscribe();
  }

}
